import { render, staticRenderFns } from "./AboutUse.vue?vue&type=template&id=44dcd566&scoped=true&"
import script from "./AboutUse.vue?vue&type=script&lang=js&"
export * from "./AboutUse.vue?vue&type=script&lang=js&"
import style0 from "./AboutUse.vue?vue&type=style&index=0&id=44dcd566&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dcd566",
  null
  
)

export default component.exports